import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { CodeBlock, dracula } from "react-code-blocks";
import { getApiDomain } from "../../utils";

export default ({
  open,
  onClose,
  inbox,
}: {
  open: boolean;
  onClose: () => void;
  inbox: any;
}) => {
  const getCurlCommand = (inboxId: string | null | undefined) => {
    return `forward-email=${getApiDomain()}/inboxes/${inbox.id}/webhook
or to send to multiple inboxes:
forward-email=example@gmail.com,${getApiDomain()}/inboxes/${inbox.id}/webhook`;
  };

  if (!inbox) return <></>;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Inbox Webhook Instructions
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Configure your email domain using https://forwardemail.net/ to send
          emails to the below address when new emails are recieved.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          Send HTTP Post to following endpoint:
        </Typography>
        <CodeBlock
          language={"bash"}
          text={`${getApiDomain()}/inboxes/${inbox.id}/webhook`}
          wrapLines
          codeBlock
          showLineNumbers={false}
          theme={dracula}
        />
        <Typography sx={{ mt: 2 }}>Example DNS TXT record</Typography>
        <CodeBlock
          language={"bash"}
          text={getCurlCommand(inbox.id)}
          wrapLines
          codeBlock
          showLineNumbers={false}
          theme={dracula}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
